import { render, staticRenderFns } from "./RemolcadorIndex.vue?vue&type=template&id=230152b6"
import script from "./RemolcadorIndex.vue?vue&type=script&lang=js"
export * from "./RemolcadorIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports